import { render, staticRenderFns } from "./OriginalToolTip.vue?vue&type=template&id=8229187c&scoped=true"
import script from "./OriginalToolTip.vue?vue&type=script&lang=js"
export * from "./OriginalToolTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8229187c",
  null
  
)

export default component.exports